import styled, { keyframes } from 'vue3-styled-components';

const windowOpen = keyframes`
  0% {
    left: 60px;
  }
  100% {
    left: 0;
  }
`;

const ContainerSc = styled('div')`
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100vw;
  bottom: 0;
  background: #fff;
  animation: ${windowOpen} 0.3s 1;

  @supports (padding-top: constant(safe-area-inset-top)) or (padding-top: env(safe-area-inset-top)) {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
  }
  * {
    box-sizing: border-box;
  }
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 52px 0 8px;
    width: 100%;

    span {
      margin: 0 auto;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
    }
  }
  .content {
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    background: #f5f5f5;

    .share-person {
      margin: 12px 14px;
      padding: 7px 12px 7px 18px;
      height: 66px;
      background: #fff;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .avatar {
        width: 52px;
        height: 52px;
        border-radius: 50%;
      }
      span {
        flex-grow: 1;
        text-align: left;
        margin: 0 12px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;

        .tip {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }

    .title-setting {
      margin: 12px 14px;
      position: relative;
      padding: 7px 18px;
      height: 66px;
      background: #fff;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-label {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        white-space: nowrap;
      }

      input {
        flex-grow: 1;
        height: 32px;
        border: none;
        outline: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        font-size: 16px;
        font-weight: 400;
        color: #828289;
        line-height: 22px;
        padding-right: 60px;
        flex-shrink: 1;
        overflow: hidden;
      }

      .text-length {
        position: absolute;
        right: 44px;
        font-size: 12px;
        font-family: PingFangSC-Regular, "PingFang SC";
        font-weight: 400;
        color: rgb(189, 189, 193);
        line-height: 17px;
      }

      .clear-title {
        position: absolute;
        right: 5px;
        padding: 13px;

        img {
          display: block;
        }
      }
    }

    .share-style {
      background: #fff;
      border-radius: 12px;
      margin: 12px 14px 12px;

      .style-list {
        display: grid;
        grid-template-columns: repeat(3, calc(33.3% - 6.7px));
        grid-gap: 12px 10px;
        padding: 0 18px 18px;

        .style-item {
          .main {
            position: relative;

            .main-img {
              width: 100%;
              height: 80px;
              display: block;
              border-radius: 6px;
              border: 2px solid transparent;
            }
            .main-title {
              position: absolute;
              z-index: 1;
              top: 0;
              right: 0;
            }

            .quoted-price {
              position: absolute;
              bottom: 0;
              z-index: 1;
              width: 100%;
              height: 22px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #2BC689;
              border-radius: 0 0 6px 6px;

              > span {
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 17px;
              }
            }

            .quoted-img {
              position: absolute;
              left: 50%;
              top: 50%;
              z-index: 1;
              transform: translate(-50%, calc(-50% - 11px));
            }
          }
          > span {
            display: block;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            margin-top: 8px;
            text-align: left;
          }
        }
        .style-item.active {
          .main {
            .main-img {
              border: 2px solid #2BC689;
            }

            &::after {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 4px;
              content: "";
              background: rgba(0, 0, 0, 0.2);
            }
          }

          > span {
            color: #2BC689;
          }
        }
      }
    }
    .share-aging {
      background: #fff;
      border-radius: 12px;
      margin: 12px 14px 12px;
      padding-bottom: 20px;

      .list {
        .list-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 18px 12px;
          height: 70px;
          background: #F5F5F5;
          border-radius: 12px;

          .left {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-left: 12px;
            height: 100%;
            
            .top {
              display: flex;
              align-items: center;
              flex: 1;

              .list-title {
                position: relative;
                width: 100%;
                height: 20px;
                font-family: 'PingFang SC-Medium', 'PingFang SC', 'Source Han Sans CN-Medium', 'Source Han Sans CN';
                text-align: left;
                font-size: 14px;
                font-weight: 500;
                color: #333333;
                line-height: 20px;

                .sub-title {
                  position: absolute;
                  left: 0px;
                  bottom: -21px;
                  height: 16px;
                  font-family: 'PingFang SC-Regular', 'PingFang SC', 'Source Han Sans CN-Regular', 'Source Han Sans CN';
                  font-size: 12px;
                  font-weight: 400;
                  color: #979797;
                  line-height: 16px;
                }
              }
            }
            .btm {
              height: 25%;
            }
          }
          .right {
            margin-right: 24px;

            .viewing-time-box {
              height: 32px;
              background: #2BC689;
              border-radius: 17px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0 8px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 20px;

              img {
                margin-left: 6px;
              }
            }

            &.viewing-time {
              margin-right: 16px;
            }
          }
        }
        .list-item.selected-item {
          background: rgba(43, 198, 137, 0.15);
        }
      }
      .bottom-tip {
        padding-top: 4px;
        height: 20px;
        font-family: 'PingFang SC-Regular', 'PingFang SC', 'Source Han Sans CN-Regular', 'Source Han Sans CN';
        font-size: 14px;
        font-weight: 400;
        color: #FFC32B;
        line-height: 20px;
      }
    }
  }
  .bottom {
    width: 100%;
    flex-shrink: 0;
    background: #f5f5f5;
    
    .bottom-btn {
      width: 80%;
      height: 44px;
      background: linear-gradient(135deg, #DBDBDB 0%, #D5D5D5 100%);
      box-shadow: 0px 2px 16px 0px rgba(219, 219, 219, 0.75);
      border-radius: 32px;
      border: none;
      font-family:  'PingFang SC-Semibold', 'PingFang SC', 'Source Han Sans CN-Semibold', 'Source Han Sans CN';
      font-size: 16px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 22px;
      margin: 20px 0 26px;
    }
    .bottom-btn.active {
      background: linear-gradient(135deg, #2DCA8C 0%, #26C285 100%);
      box-shadow: 0px 2px 16px 0px #92E2C4;
    }
  }
  @supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
    .bottom {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  .bottom2 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 22px;
    padding: 20px 20px 40px;
    background: #f5f5f5;
    width: 100%;

    .share {
      max-width: 176px;
      height: 60px;
      background: rgba(0,0,0,0.12);
      border-radius: 8px;
      flex: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #2BC689;
      background: #FFFFFF;
      border: 1px solid #2BC689;
      box-sizing: border-box;

      .sub-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 16.8px;
        transform: scale(0.83);
      }

      &.active {
        color: #FFFFFF;
        background: linear-gradient(135deg, #2DCA8C 0%, #26C285 100%);
        border: 0;
      }

      &.single {
        width: 90.3%;
        max-width: 374px;
      }
    }
  }

  .background {
    position: fixed;
    height: 100vh;
    width: 100vw;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .quoted-price-container {
    height: 192px;

    .quoted-list {
      height: 100%;
      overflow: auto;

      .quoted-item {
        height: 44px;
        background: rgba(255,255,255,0);
        border-radius: 6px;
        border: 1px solid rgba(0,0,0,0.06);
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .name {
          flex: auto;
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 8px;
        }

        .price {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 31px;

          span {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF5252;
            line-height: 20px;
          }

          .radio {
            width: 44px;
            height: 44px;
            padding: 10px 8px 10px 12px;
            margin-left: 4px;
          }
        }
      }
    }

    .confirm {
      width: 88.4%;
      height: 44px;
      background: linear-gradient(135deg, #2DCA8C 0%, #26C285 100%);
      box-shadow: 0px 2px 16px 0px #92e2c4;
      border-radius: 32px;
      margin: 16px auto;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 44px;
    }
  }
`;

const CardTitleSc = styled('div')`
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  padding: 15px 18px 11px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fold-button {
    width: 60px;
    height: 24px;
    background: #F5F7FA;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    color: #828289;
    line-height: 17px;

    img {
      display: block;

      &.unfolded {
        transform: rotate(180deg);
      }
    }
  }
`;

export { ContainerSc, CardTitleSc };
